/**
 * Copyright (c) 2017 CA. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

// @flow

// Portal variables
export const PORTAL_USE_PAPI = true;
export const PORTAL_USE_SESSION = true;
export const PORTAL_TENANT_ID = process.env.PORTAL_TENANT_ID || '';
export const PORTAL_DETECT_TENANT_ID = process.env.PORTAL_DETECT_TENANT_ID ?
 process.env.PORTAL_DETECT_TENANT_ID === 'true' : false;

// API gateway variables
export const SERVER_HOSTNAME = process.env.SERVER_HOSTNAME || 'apim.dev.ca.com';
export const SERVER_PORT = process.env.SERVER_PORT || '38443';

// OTK client variables
export const CLIENT_ID = process.env.CLIENT_ID;
export const CLIENT_SCOPE = process.env.CLIENT_SCOPE || 'openid profile email';
export const CLIENT_REDIRECT_URI = process.env.CLIENT_REDIRECT_URI || 'http://localhost:3000';
